import { createApiRef } from '@backstage/core-plugin-api';
import { DevBoxServiceGroup } from './service-groups/types';

export interface DevBoxApi {
  /** Placeholder endpoint until the DevBox backend exists. */
  listServiceGroups(): Promise<DevBoxServiceGroup[]>;
}

export const devboxApiRef = createApiRef<DevBoxApi>({
  id: 'plugin.devbox.api',
});
